import styled from '@emotion/styled';
import { SimpleCard } from '@naf-simba/sections-cards';

export const NavCard = styled(SimpleCard)`
  height: 100%;

  /* Simba caps a card's width per size, and on phones at 328px for every size.
     The NAF grid column is wider than that on all but the narrowest handsets,
     so a capped card stops short of the blocks above and below it. In a grid
     the cell is the width we want. !important because Simba's own phone-width
     media query rule has equal specificity and can be inserted after ours,
     winning the cascade depending on render order. */
  max-width: 100% !important;
`;

export default NavCard;
